/*
 * @Description: 对账函接口
 * @Autor: txp
 * @Date: 2021-05-12 16:55:57
 */
import request from "@/utils/request";
// 1.对账函列表
export const CustomerStatementControllerList = (data) =>request.post('/dms/dmsHdCustomerStatementController/findOwnStatementList',data)
//2、对账函列表详情
export const CustomerStatementControllerQuery = (data) =>request.get('/dms/dmsHdCustomerStatementController/queryByStatementCode',data)
// 3.作废对账单
export const CancelStatement = (data) =>request.post('/dms/dmsHdCustomerStatementController/cancelStatement',data)
// 4.客户确认对账单
export const CustomerConfirm = (data) =>request.post('/dms/dmsHdCustomerStatementController/customerConfirm',data)
// 5.查询客户问题反馈详情
export const QueryDataByStatementId = (data) =>request.get('/dms/dmsHdCustomerStatementFeedbackController/getLastFeedbackByStatementCode',data)
// 6.提交客户反馈信息
export const ControllerSave = (data) =>request.post('/dms/dmsHdCustomerStatementFeedbackController/statementFeedback',data)
// 7.获取验证码 
export const GetPhoneVerificationCode = (data) =>request.post('/dms/dmsHdCustomerStatementController/sendStatementConfirmVerificationCode',data)
// 导出对账单明细：发货/核销费用/收款 明细 
// export const ExportDetail = (data) =>request.get('/dms/dmsHdCustomerStatementController/getExportDetailByStatementCode',data)

// 下载查询
export const ExportDeliverGoodsDetail = (data) =>request.get('/dms/dmsHdCustomerStatementController/getExportDeliverGoodsDetailByStatementCode',data)
export const ExportReceivePaymentDetail = (data) =>request.get('/dms/dmsHdCustomerStatementController/getExportReceivePaymentDetailByStatementCode',data)
export const ExportAuditCostDetail = (data) =>request.get('/dms/dmsHdCustomerStatementController/getExportAuditCostDetailByStatementCode',data)

// 导出对账单明细下载接口
export const DownloadExcelFile = (data) =>request.getDown('/upload/downloadController/downloadExcelFile',data)
// 获取发票类型
export const invoiceType = (data) => request.get('/mdm/mdmCustomerProController/queryByCustomerCode',data)

//多账函获取手机好嘛
export const getPhoneNumber = (data) => request.get('/dms/dmsHdCustomerStatementController/getConfirmContactByStatementCode',data)

